import { IScreen } from './iScreen';
import GameScreen from './gameScreen';

// Confirmation gate for starting a new game, since it wipes all saved progress
// (the interaction cache and the current run). Defaults to "No" for safety.
class NewGameConfirmScreen implements IScreen{
    option : number = 1; //start on "No"
    options : string[] = ["Yes", "No"];
    lastPointerFrame : number = -1;

    constructor(){

    }

    setup(){

    }

    windowResized(): void {

    }

    draw(){
        buffer.background(0);
        buffer.textAlign(buffer.CENTER, buffer.CENTER);
        buffer.noStroke();

        buffer.fill(255);
        buffer.textSize(30);
        buffer.text("Start New Game?", 0, -90);

        buffer.fill(255, 100, 100);
        buffer.textSize(16);
        buffer.text("All progress will be lost.", 0, -40);

        //let the mouse highlight whichever option it hovers
        if(!isMobile){
            let hovered = this.optionAt(this.pointerBufferPos());
            if(hovered !== -1){
                this.option = hovered;
            }
        }

        buffer.textSize(24);
        for(let i = 0; i < this.options.length; i++){
            if(i === this.option){
                buffer.fill(205 + (p5js.sin(p5js.frameCount / 5.0) * 25), 0, 0);
                buffer.text("> " + this.options[i] + " <", 0, 30 + i * 36);
            }else{
                buffer.fill(255);
                buffer.text(this.options[i], 0, 30 + i * 36);
            }
        }
    }

    // Pointer position (mouse or first touch) in buffer coordinates.
    pointerBufferPos(): {x: number, y: number} {
        let px = p5js.mouseX;
        let py = p5js.mouseY;
        if(p5js.touches && p5js.touches.length > 0){
            let t = p5js.touches[0] as any;
            px = t.x;
            py = t.y;
        }
        return { x: px/pixelSize - buffer.width/2, y: py/pixelSize - buffer.height/2 };
    }

    // Index of the Yes/No option under the pointer, or -1. Options sit at
    // y = 30 + i*36, centered on x=0.
    optionAt(pos: {x: number, y: number}): number {
        for(let i = 0; i < this.options.length; i++){
            let oy = 30 + i * 36;
            if(Math.abs(pos.x) < 120 && Math.abs(pos.y - oy) < 16){
                return i;
            }
        }
        return -1;
    }

    // Shared by mouse and touch; frame guard dedupes p5's dual dispatch.
    handlePointer(){
        if(this.lastPointerFrame === p5js.frameCount){
            return;
        }
        this.lastPointerFrame = p5js.frameCount;

        let idx = this.optionAt(this.pointerBufferPos());
        if(idx === -1){
            return;
        }
        this.option = idx;
        if(this.options[idx] === "Yes"){
            (screens["game"] as GameScreen).startNewGame();
            this.option = 1; //reset for next time
            currentScreen = "game";
            iScreen = screens[currentScreen];
        }else{
            this.cancel();
        }
    }

    keyPressed(){
        if(p5js.keyCode == p5js.UP_ARROW || p5js.key.toLowerCase() === 'w'){
            this.option = (this.option + this.options.length - 1) % this.options.length;
        }else if(p5js.keyCode == p5js.DOWN_ARROW || p5js.key.toLowerCase() === 's'){
            this.option = (this.option + 1) % this.options.length;
        }else if(p5js.keyCode == p5js.ENTER || p5js.key == ' '){
            if(this.options[this.option] === "Yes"){
                (screens["game"] as GameScreen).startNewGame();
                this.option = 1; //reset for next time
                currentScreen = "game";
                iScreen = screens[currentScreen];
            }else{
                this.cancel();
            }
        }else if(p5js.keyCode === p5js.ESCAPE){
            this.cancel();
        }
    }

    cancel(){
        this.option = 1; //reset default to "No"
        currentScreen = "mainMenu";
        iScreen = screens[currentScreen];
    }

    keyReleased(){

    }

    mousePressed(){
        this.handlePointer();
    }

    mouseReleased(){

    }

    touchStarted(){
        this.handlePointer();
    }

    touchEnded(){

    }

    touchMoved(): void {

    }

    mouseWheel(event: any): void {

    }

}

export default NewGameConfirmScreen;
